import React from 'react';
import { FieldValues, UseControllerProps, useController } from 'react-hook-form';
import Box from '@mui/material/Box';
import { InputPassword, InputPasswordProps } from './InputPassword';

export type ControlledInputProps<T extends FieldValues> = InputPasswordProps &
  UseControllerProps<T> & {
    errorMessage?: string;
  };

export const InputPasswordWrapper = <T extends FieldValues>({
  name,
  control,
  errorMessage,
  ...props
}: ControlledInputProps<T>) => {
  const { field } = useController({ control, name });

  return (
    <Box>
      <InputPassword
        {...field}
        {...props}
        helperText={errorMessage}
        fullWidth
        errorMessage={errorMessage}
      />
    </Box>
  );
};
